import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setPurchasePivotChart, duplicatePivotChart } from '../../actions/purchaseOrders_actions';
import ChartModal from '../../components/Purchase/chartModal';

let chartModal = reduxForm({
  form: 'chartModal',
})(ChartModal);

const selector = formValueSelector('chartModal');

function mapStateToProps(state) {
    return {
      purchasePivotChartsIsLoading: state.purchaseOrders.purchasePivotChartsIsLoading,
      purchasePivotCharts: state.purchaseOrders.purchasePivotCharts,
      purchasePivotChartsError: state.purchaseOrders.purchasePivotChartsError,
      isDuplicatingPurchasePivotChart: state.purchaseOrders.isDuplicatingPurchasePivotChart,
      duplicatedPurchasePivotChart: state.purchaseOrders.duplicatedPurchasePivotChart,
    };
}

export default connect(mapStateToProps, { setPurchasePivotChart, duplicatePivotChart })(chartModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/chartModal.jsx